


import AIMLSection from "./AIMLSection/AIMLSection";
import CADSection from "./CADSection/CADSection";
import "./CourseComponents.css";
import DataScienceSection from "./DataScienceSection/DataScienceSection";
import PythonSection from "./PythonSection/PythonSection";


function CourseComponents() {

    return (
        <section className="course-section p-2">

            <div className="course-container">

                <h2 className="mt-5" style={{
                    textAlign:'center',
                    fontWeight:800,
                
                    
                }}>CAD Engineer?                 
                </h2>

                <CADSection />

                <PythonSection />

                <AIMLSection />

                <DataScienceSection />

            </div>

        </section>
    );
}

export default CourseComponents;